import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const ContactMethods = () => {
  const [activeMethod, setActiveMethod] = useState("phone");

  const contactMethods = [
    {
      id: "phone",
      title: "Phone Support",
      description: "Speak directly with our admission's office",
      icon: "Phone",
      color: "bg-primary",
      details: {
        primary: "+254(0) 705636443",
        secondary: "+254(0) 705636443",
        hours: "Mon-Fri: 8:00 AM - 5:00 PM",
        response: "Immediate assistance",
      },
    },
    {
      id: "email",
      title: "Send Us an Email",
      description: "Get detailed responses to your queries via Email",
      icon: "Mail",
      color: "bg-accent",
      details: {
        primary: "info@karumotti.ac.ke",
        secondary: "admissions@karumotti.ac.ke",
        hours: "Response within 12 hours",
        response: "Detailed information",
      },
    },
    {
      id: "chat",
      title: "Live Chat",
      description: "Real-time assistance during business hours",
      icon: "MessageCircle",
      color: "bg-success",
      details: {
        primary: "Available on website",
        secondary: "WhatsApp: +254(0) 705636443",
        hours: "Mon-Sat: 8:00 AM - 5:00 PM",
        response: "Instant replies",
      },
    },
    {
      id: "visit",
      title: "Visit Us",
      description: "Schedule a personalized visit",
      icon: "MapPin",
      color: "bg-warning",
      details: {
        primary: "3Km Off Kwa Amos Junction, Meru-Maua Road",
        secondary: "Institute's Contacts",
        hours: "Mon-Sat: 10:00 AM - 4:00 PM",
        response: "Guided tour & counseling",
      },
    },
  ];

  const activeMethodData = contactMethods?.find(
    (method) => method?.id === activeMethod
  );

  return (
    <section className="py-16 lg:py-24 bg-blue-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Reach us through Your Preferred Method
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Choose your preferred method of communication. Our team is ready to
            assist you with admissions, course information, and career guidance.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Contact Method Tabs */}
          <div className="space-y-4">
            {contactMethods?.map((method) => (
              <div
                key={method?.id}
                onClick={() => setActiveMethod(method?.id)}
                className={`p-6 rounded-xl border-2 cursor-pointer transition-all duration-300 ${
                  activeMethod === method?.id
                    ? "border-primary bg-primary/5 shadow-lg"
                    : "border-border bg-card hover:border-primary/50 hover:shadow-md"
                }`}
              >
                <div className="flex items-start space-x-4">
                  <div
                    className={`w-12 h-12 ${method?.color} rounded-lg flex items-center justify-center flex-shrink-0`}
                  >
                    <Icon name={method?.icon} size={24} color="white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-foreground mb-2">
                      {method?.title}
                    </h3>
                    <p className="text-muted-foreground">
                      {method?.description}
                    </p>
                  </div>
                  <div
                    className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                      activeMethod === method?.id
                        ? "border-primary bg-primary"
                        : "border-border"
                    }`}
                  >
                    {activeMethod === method?.id && (
                      <div className="w-2 h-2 bg-white rounded-full"></div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Active Method Details */}
          <div className="lg:pl-8">
            <div className="bg-card rounded-2xl p-8 shadow-lg border border-border">
              <div className="flex items-center space-x-4 mb-6">
                <div
                  className={`w-16 h-16 ${activeMethodData?.color} rounded-xl flex items-center justify-center`}
                >
                  <Icon name={activeMethodData?.icon} size={28} color="white" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-foreground">
                    {activeMethodData?.title}
                  </h3>
                  <p className="text-muted-foreground">
                    {activeMethodData?.description}
                  </p>
                </div>
              </div>

              <div className="space-y-6">
                <div className="flex items-center space-x-3 p-4 bg-muted rounded-lg">
                  <Icon name="Phone" size={20} className="text-primary" />
                  <div>
                    <p className="font-semibold text-foreground">
                      {activeMethodData?.details?.primary}
                    </p>
                    <p className="text-sm text-muted-foreground">
                      Primary Contact
                    </p>
                  </div>
                </div>

                <div className="flex items-center space-x-3 p-4 bg-muted rounded-lg">
                  <Icon name="Mail" size={20} className="text-primary" />
                  <div>
                    <p className="font-semibold text-foreground">
                      {activeMethodData?.details?.secondary}
                    </p>
                    <p className="text-sm text-muted-foreground">
                      Secondary Contact
                    </p>
                  </div>
                </div>

                <div className="flex items-center space-x-3 p-4 bg-muted rounded-lg">
                  <Icon name="Clock" size={20} className="text-primary" />
                  <div>
                    <p className="font-semibold text-foreground">
                      {activeMethodData?.details?.hours}
                    </p>
                    <p className="text-sm text-muted-foreground">
                      Availability
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-border">
                <Button
                  variant="default"
                  fullWidth
                  size="lg"
                  iconName={activeMethodData?.icon}
                  iconPosition="left"
                >
                  Connect via {activeMethodData?.title}
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-card rounded-2xl p-8 shadow-card-lg border border-border">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-foreground mb-2">
              Institute Location
            </h3>
            <p className="text-muted-foreground">
              Visit us at our modern facility
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8 items-center">
            <div className="lg:col-span-2">
              <div className="bg-muted rounded-xl overflow-hidden h-80">
                <iframe
                  width="100%"
                  height="100%"
                  loading="lazy"
                  title="KTTI Location"
                  referrerPolicy="no-referrer-when-downgrade"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1994.8950167547384!2d37.74920108862461!3d0.21575133672097765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x178838ef2c157f43%3A0x2703831c509ff321!2sKarumo%20Technical%20Training%20Institute!5e0!3m2!1sen!2ske!4v1761139421241!5m2!1sen!2ske"
                  className="border-0"
                ></iframe>
              </div>
            </div>

            <div className="space-y-6">
              <div className="flex items-start space-x-3">
                <Icon name="MapPin" size={20} className="text-primary mt-1" />
                <div>
                  <h4 className="font-semibold text-foreground mb-1">
                    Address
                  </h4>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li>📍 KARUMO TECHNICAL TRAINING INSTITUTE</li>
                    <li>P.O BOX 276-60602 KIANJAI, MERU</li>
                    <li>📞 +254(0)705636443</li>
                    <li>✉️ info@karumotti.ac.ke</li>
                  </ul>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <Icon name="Clock" size={20} className="text-primary mt-1" />
                <div>
                  <h4 className="font-semibold text-foreground mb-1">
                    Visiting Hours
                  </h4>
                  <p className="text-sm text-muted-foreground">
                    Mon - Fri: 8:00 AM - 5:00 PM
                  </p>
                </div>
              </div>

              <Button
                variant="default"
                fullWidth
                iconName="Navigation"
                iconPosition="left"
              >
                Get Directions
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactMethods;
